import { getImageURLBasedOnEvent } from "constants/media";
import {
  MoreHorizontal,
  Heart,
  MessageCircle,
  Send,
  Bookmark,
} from "lucide-react";
import { truncateText } from "./YoutubePostPreview";

const InstagramPostPreview = ({ selectedEvent, title }) => {
  const imageURL = getImageURLBasedOnEvent(selectedEvent);

  return (
    <div className="w-full h-full mx-auto border bg-[white]  rounded-lg overflow-hidden shadow-sm mt-[1vh]">
      {/* Header */}
      <div className="flex items-center justify-between p-[1.5vh]">
        <div className="flex items-center space-x-[1.5vh]">
          <div className="w-[4vh] h-[4vh] bg-red-200 rounded-full flex items-center justify-center text-red-500 font-bold text-[2vh]">
            S
          </div>
          <div className="text-[1.9vh]">
            <p className="font-manropeSB text-black">SOOMUCH.ai</p>
            <p className="text-[1.7vh] text-gray-500">Madhapur, Hyderabad</p>
          </div>
        </div>
        <MoreHorizontal className="h-[2.5vh] w-[2.5vh] text-gray-500" />
      </div>

      {/* Post Image */}
      <div className="w-full overflow-hidden rounded-lg">
        <img
          src={imageURL}
          alt="Instagram Post"
          className="w-full h-[38vh] object-contain"
        />
      </div>

      {/* Action Buttons */}
      <div className="flex items-center justify-between px-[1.5vh] py-[1vh]">
        <div className="flex space-x-[2vh]">
          <Heart className="w-[2.5vh] h-[2.5vh] text-gray-700 cursor-pointer" />
          <MessageCircle className="w-[2.5vh] h-[2.5vh] text-gray-700 cursor-pointer" />
          <Send className="w-[2.5vh] h-[2.5vh] text-gray-700 cursor-pointer" />
        </div>
        <Bookmark className="w-[2.5vh] h-[2.5vh] text-gray-700 cursor-pointer" />
      </div>

      {/* Likes */}
      <div className="px-[1.5vh] text-[1.6vh] font-manropeSB text-gray-700">
        Liked by <span className="font-bold">Ankit</span> and{" "}
        <span className="font-bold">4,486 others</span>
      </div>

      {/* Caption */}
      <div className="px-[1.5vh] py-[0.5vh] text-[1.6vh] text-gray-700">
        <span className="font-bold">SOOMUCH.ai</span> {truncateText(title, 25)}
      </div>

      {/* Date */}
      <div className="px-[1.5vh] pb-[1vh] text-[1.5vh] text-gray-400">
        May 10
      </div>
    </div>
  );
};

export default InstagramPostPreview;
